import styles from './Button.module.scss.js';
import Icon from '../Icon/Icon.js';
import cx from 'classnames';
import { forwardRef } from 'react';
import { jsxs, jsx } from 'react/jsx-runtime';

const ButtonColor = {
  Blue: "Blue",
  Green: "Green",
  Red: "Red"
};
const Size = {
  Regular: "Regular",
  Small: "Small"
};
const Style = {
  Filled: "",
  Outlined: "Outlined",
  Naked: "Naked"
};
const Button = ({
  buttonText,
  buttonColor = ButtonColor.Blue,
  buttonSize = Size.Regular,
  buttonStyle = Style.Filled,
  buttonDescriptionText,
  leftIconName,
  rightIconName,
  iconColor,
  disabled,
  onClick,
  className,
  testId = "ogFeLibraryButtonComponent",
  buttonTextDataTestId = "buttonTextId",
  buttonDescriptionTextDataTestId = "buttonSubTextId",
  ariaLabelText
}, ref) => {
  return /* @__PURE__ */ jsxs("button", {
    "data-test-id": testId,
    className: cx(styles.button, styles[buttonSize], buttonStyle && styles[buttonStyle], styles[buttonColor], className),
    disabled,
    onClick,
    ref,
    "aria-label": ariaLabelText,
    children: [leftIconName && /* @__PURE__ */ jsx(Icon, {
      className: styles.leftIcon,
      iconName: leftIconName,
      iconColor
    }), buttonDescriptionText ? /* @__PURE__ */ jsxs("div", {
      className: styles.buttonTypeDescription,
      children: [/* @__PURE__ */ jsx("span", {
        "data-test-id": buttonTextDataTestId,
        children: buttonText
      }), /* @__PURE__ */ jsx("span", {
        "data-test-id": buttonDescriptionTextDataTestId,
        className: styles.buttonDescription,
        children: buttonDescriptionText
      })]
    }) : /* @__PURE__ */ jsx("span", {
      "data-test-id": buttonTextDataTestId,
      children: buttonText
    }), rightIconName && /* @__PURE__ */ jsx(Icon, {
      className: styles.rightIcon,
      iconName: rightIconName,
      iconColor
    })]
  });
};
var Button$1 = /* @__PURE__ */ forwardRef(Button);

export { Button$1 as default };
//# sourceMappingURL=Button.js.map
